(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stirwell-holiday-heels"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const init=(scope=document)=>{
      scope.querySelectorAll('[data-sw-section]').forEach(root=>{
        if(root.dataset.swReady==='true')return;
        root.dataset.swReady='true';
        const track=root.querySelector('.sw-gallery-track');
        const slides=Array.from(root.querySelectorAll('.sw-gallery-slide'));
        const thumbs=Array.from(root.querySelectorAll('[data-sw-slide]'));
        const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const video=root.querySelector('[data-sw-video]');
        if(video){
          video.muted=true;
          if(reduced){video.autoplay=false;video.pause();}
          else if(window.IntersectionObserver){
            const videoObserver=new IntersectionObserver(entries=>{
              entries.forEach(entry=>{if(entry.isIntersecting)video.play().catch(()=>{});else video.pause();});
            },{threshold:.1});
            videoObserver.observe(video);
          }
        }
        const move=index=>track.scrollTo({left:track.clientWidth*index,behavior:reduced?'auto':'smooth'});
        thumbs.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.swSlide))));
        track.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const index=Math.round(track.scrollLeft/track.clientWidth);move(Math.max(0,Math.min(slides.length-1,index+(event.key==='ArrowRight'?1:-1))));});
        let ticking=false;
        track.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{const index=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));root.querySelector('[data-sw-count]').textContent=String(index+1);ticking=false;});},{passive:true});

        const form=root.querySelector('.sw-product-form');
        const sizeInputs=Array.from(root.querySelectorAll('[data-sw-variant]'));
        const buttons=Array.from(root.querySelectorAll('[data-sw-add]'));
        const prices=root.querySelectorAll('[data-sw-price]');
        const compare=root.querySelector('[data-sw-compare]');
        const previous=root.querySelector('[data-sw-previous]');
        let submitting=false;
        const restore=()=>{
          submitting=false;
          if(form)form.removeAttribute('aria-busy');
          const selected=sizeInputs.find(input=>input.checked);
          buttons.forEach(button=>{
            if(button.dataset.initialDisabled===undefined)button.dataset.initialDisabled=String(button.disabled);
            button.disabled=selected?!(selected.dataset.available==='true'&&Number(selected.dataset.amount)>0):button.dataset.initialDisabled==='true';
            button.textContent=button.disabled?button.dataset.labelSold:button.dataset.labelReady;
          });
        };
        buttons.forEach(button=>button.dataset.initialDisabled=String(button.disabled));
        sizeInputs.forEach(option=>option.addEventListener('change',()=>{
          if(!option.checked)return;
          prices.forEach(price=>price.textContent=option.dataset.price);
          previous.hidden=!(Number(option.dataset.compareAmount)>Number(option.dataset.amount));
          compare.textContent=option.dataset.compare;
          restore();
          if(window.location.pathname.includes('/products/')){const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);}
        }));
        restore();
        if(form)form.addEventListener('submit',event=>{
          if(submitting){event.preventDefault();return;}
          submitting=true;
          form.setAttribute('aria-busy','true');
          buttons.forEach(button=>{button.disabled=true;button.textContent=button.dataset.labelAdding;});
        });
        window.addEventListener('pageshow',restore);

        const sticky=root.querySelector('[data-sw-sticky]');
        const primary=root.querySelector('.sw-buy-area [data-sw-add]');
        if(sticky&&primary&&window.IntersectionObserver){const observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0});observer.observe(primary);}
      });
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
    document.addEventListener('shopify:section:load',event=>init(event.target.parentElement));
  })();

  } catch(e) { console.error(e); }
})();
})();
